import Vue from 'vue'
import App from './App.vue'
import '@/utils/filter'
import '@/icons' // icon
import {
  Row,
  Col,
  // Row,
  // Col,
  Switch,
  Button,
  ButtonGroup,
  Select,
  Option,
  Icon,
  Input,
  Autocomplete,
  InputNumber,
  Dialog,
  Upload,
  Radio,
  RadioGroup,
  Pagination,
  Loading,
  Message,
  MessageBox,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Checkbox,
  CheckboxGroup,
  // CheckboxButton,
  // Form,
  // Tabs,
  Popover,
  Tooltip,
  Form,
  FormItem,
  DatePicker,
  Timeline,
  TimelineItem,
  Image
  // TimePicker
} from 'element-ui'
import './styles/element-variables.scss'
Vue.use(Row)
Vue.use(Col)
Vue.use(ButtonGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
// Vue.use(CheckboxButton)
// Vue.use(Row)
// Vue.use(Col)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Icon)
Vue.use(Input)
Vue.use(Autocomplete)
Vue.use(InputNumber)
Vue.use(Dialog)
Vue.use(Upload)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Pagination)
Vue.use(Tabs)
Vue.use(Table)
Vue.use(TableColumn)
// Vue.use(Form)

// Vue.use(Tabs)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(Form)
Vue.use(Switch)
Vue.use(FormItem)
Vue.use(TabPane)
Vue.use(DatePicker)
Vue.use(TimelineItem)
Vue.use(Timeline)
Vue.use(Image)
// Vue.use(TimePicker)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message

import router from './router'
import store from './store'

import components from '@/components/components.js'
Vue.use(components)

import './styles/common.css'
import './styles/fonts/iconfont.css'
import '@/utils/rem'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// store.dispatch('aaa')
